import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BrandCardLight } from '../components/Cards'
import { SectionHead } from '../components/UI'
import { Icon } from '../components/Icons'
import { BRANDS } from '../data'
import experiencesBanner from '../assets/logo/Signature Experiences in Santorini.png'

const SOLUTIONS = [
  { icon: 'plane', title: 'Flights', desc: 'Competitive domestic & international air ticketing with flexible travel options.' },
  { icon: 'bus', title: 'Transportation & Fleet Services', desc: 'Private cars, coaches, buses and corporate transportation solutions.' },
  { icon: 'hotel', title: 'Hotels', desc: 'Worldwide hotel reservations from budget stays to luxury resorts.' },
  { icon: 'inr', title: 'Forex', desc: 'Foreign currency exchange assistance through authorised partners.' },
  { icon: 'beach', title: 'Holidays', desc: 'Customized domestic & international holiday packages for every traveller.' },
  { icon: 'compass', title: 'Cruises', desc: 'Luxury cruise holidays with world-class cruise lines.' },
  { icon: 'passport', title: 'Visa', desc: 'Professional visa processing and documentation assistance.' },
  { icon: 'shield', title: 'Insurance', desc: 'Comprehensive travel insurance for a safe and worry-free journey.' },
  { icon: 'envelope', title: 'Document Attestation', desc: 'Attestation and legalization services for personal, educational and commercial documents.' },
  { icon: 'users', title: 'MICE', desc: 'Meetings, Incentives, Conferences & Exhibitions management.' },
  { icon: 'globe', title: 'DMC', desc: 'End-to-end destination management services across Asia.' },
  { icon: 'backpack', title: 'Baggage Logistics', desc: 'Reliable baggage forwarding and excess baggage solutions.' }
]

const HOSPITALITY_SOLUTIONS = [
  { icon: 'star', title: 'Luxury Hotels', desc: 'Experience world-class hospitality with premium accommodations, elegant amenities, and exceptional service.' },
  { icon: 'beach', title: 'Resorts', desc: 'Carefully selected beach, island, mountain, and wellness resorts for memorable holidays and getaways.' },
  { icon: 'briefcase', title: 'Business Hotels', desc: 'Strategically located hotels offering modern facilities, meeting spaces, and convenient access for corporate travellers.' },
  { icon: 'heart', title: 'Boutique Hotels', desc: 'Unique and stylish accommodations providing personalized service, local character, and authentic experiences.' },
  { icon: 'city', title: 'Serviced Apartments', desc: 'Fully furnished apartments with modern amenities, ideal for extended stays and family travel.' },
  { icon: 'hotel', title: 'Private Villas', desc: 'Exclusive villa accommodations offering privacy, comfort, and premium facilities for families and groups.' }
]

const ACCOMMODATION_OPTIONS = [
  'Budget Hotels', 'Standard Hotels', 'Premium Hotels', 'Luxury Hotels', 'Resorts & Villas', 'Long-Stay Accommodation'
]

function SolutionCard({ v }) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      className="hover-card"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: '#fff',
        border: '1.5px solid #e2e8f0',
        borderRadius: '12px',
        padding: '26px',
        transition: 'all 0.3s',
      }}
    >
      <div
        style={{
          width: '42px',
          height: '42px',
          background: hovered ? 'rgba(255,182,0,0.1)' : 'var(--brand-lt)',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '14px',
          transition: 'all 0.3s',
        }}
      >
        <Icon name={v.icon} size={20} color={hovered ? 'var(--secondary)' : 'var(--brand)'} />
      </div>
      <h4 style={{ fontSize: '15px', fontWeight: 700, color: '#0d1117', margin: '0 0 7px' }}>
        {v.title}
      </h4>
      <p style={{ fontSize: '12px', color: '#6b7a8f', lineHeight: 1.65, margin: 0 }}>{v.desc}</p>
    </div>
  )
}

function QuoteText({ text, style = {} }) {
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ marginBottom: '24px', ...style }}
    >
      <p style={{
        fontSize: '15px', color: hovered ? 'var(--secondary)' : '#2d3748',
        fontStyle: 'italic', margin: 0, fontWeight: 800, lineHeight: 1.7,
        transition: 'color 0.3s ease'
      }}>
        <span style={{ color: 'var(--secondary)', fontSize: '22px', fontFamily: 'Georgia, serif', marginRight: '2px' }}>“</span>
        {text}
        <span style={{ color: 'var(--secondary)', fontSize: '22px', fontFamily: 'Georgia, serif', marginLeft: '2px' }}>”</span>
      </p>
    </div>
  )
}

function SpecialCard({ title, tag, tagBg, gradient, iconColor, desc, badges, cta, onClick }) {
  const [hovered, setHovered] = useState(false)
  const color = hovered ? 'var(--secondary)' : iconColor

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: gradient,
        borderRadius: '16px',
        padding: '38px',
        border: '1px solid rgba(255,255,255,0.08)',
        transition: 'all 0.3s',
      }}
    >
      <div
        style={{
          width: '50px',
          height: '50px',
          background: `${color}22`,
          borderRadius: '13px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '20px',
          transition: 'all 0.3s',
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke={color}
          strokeWidth="1.8"
          strokeLinecap="round"
          style={{ transition: 'stroke 0.3s' }}
        >
          {title.includes('Blind') ? (
            <>
              <rect x="2" y="2" width="20" height="20" rx="4" />
              <circle cx="8" cy="8" r="1.5" fill={color} style={{ transition: 'fill 0.3s' }} />
              <circle cx="16" cy="8" r="1.5" fill={color} style={{ transition: 'fill 0.3s' }} />
              <circle cx="12" cy="12" r="1.5" fill={color} style={{ transition: 'fill 0.3s' }} />
              <circle cx="8" cy="16" r="1.5" fill={color} style={{ transition: 'fill 0.3s' }} />
              <circle cx="16" cy="16" r="1.5" fill={color} style={{ transition: 'fill 0.3s' }} />
            </>
          ) : (
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          )}
        </svg>
      </div>
      <span
        style={{
          fontSize: '9px',
          fontWeight: 700,
          letterSpacing: '1.5px',
          padding: '3px 12px',
          borderRadius: '20px',
          background: tagBg,
          color: '#fff',
        }}
      >
        {tag}
      </span>
      <h3 style={{ fontSize: '28px', fontWeight: 800, color: '#fff', margin: '16px 0 12px' }}>
        {title}
      </h3>
      <p
        style={{
          fontSize: '13px',
          color: 'rgba(255,255,255,0.55)',
          lineHeight: 1.8,
          marginBottom: '24px',
        }}
      >
        {desc}
      </p>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '24px' }}>
        {badges.map((b) => (
          <span
            key={b}
            style={{
              fontSize: '10px',
              color: 'var(--secondary)',
              border: '1px solid rgba(255,182,0,0.3)',
              borderRadius: '20px',
              padding: '3px 12px',
            }}
          >
            {b}
          </span>
        ))}
      </div>
      <button
        onClick={onClick}
        style={{
          padding: '12px 28px',
          background: 'var(--brand)',
          border: 'none',
          borderRadius: '8px',
          fontSize: '12px',
          fontWeight: 800,
          color: '#fff',
          boxShadow: '0 4px 12px rgba(2,2,191,0.2)',
        }}
      >
        {cta} →
      </button>
    </div>
  )
}

export default function Experiences() {
  const navigate = useNavigate()

  // WhatsApp Helper function
  const sendToWhatsApp = (message) => {
    const phone = '7092210922'
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
    window.open(url, '_blank')
  }

  return (
    <div className="page-enter">
      {/* Hero Banner */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          background: '#0d1117',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        }}
      >
        <img
          src={experiencesBanner}
          alt="Signature Experiences - Only at DIRA Holidays"
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: '500px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </div>

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '60px 32px' }}>
        {/* Blind Date + Honeymoon */}
        <div
          className="Experiences_special_cards_grid"
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '22px',
            marginBottom: '52px',
          }}
        >
          <SpecialCard
            title="DIRA HOLIDAYS Blind Date"
            tag="MYSTERY TRAVEL"
            tagBg="#E91E63"
            gradient="linear-gradient(135deg,#1a0a3e,#2d0a2e)"
            iconColor="#E91E63"
            desc="India's first mystery travel experience. Book a surprise trip — your destination is revealed just 24 hours before you fly. Curated entirely to your personality and budget. Just say yes."
            badges={['3–5 Days', '24hr Reveal', 'Fully Curated', 'All Inclusive']}
            cta="Take the Dare"
            onClick={() =>
              sendToWhatsApp(
                'Hello DIRA HOLIDAYS! I am interested in booking a DIRA HOLIDAYS Blind Date mystery trip.'
              )
            }
          />
          <SpecialCard
            title="DIRA HOLIDAYS Honeymoon"
            tag="HONEYMOON SPECIAL"
            tagBg="#C62828"
            gradient="linear-gradient(135deg,#1a0a0a,#2d0a0a)"
            iconColor="#C62828"
            desc="Your first journey together deserves perfection. Petal-strewn suites, private candlelight dinners, couple spa sessions & once-in-a-lifetime moments — every detail planned with love."
            badges={['Private Transfers', 'Couple Spa', 'Photo Sessions']}
            cta="Plan Together"
            onClick={() =>
              sendToWhatsApp(
                'Hello DIRA HOLIDAYS! I would like to plan a DIRA HOLIDAYS Honeymoon trip.'
              )
            }
          />
        </div>

        {/* Our Travel Solutions */}
        <div style={{ marginBottom: '80px' }}>
          <SectionHead eyebrow="OUR TRAVEL SOLUTIONS" title="Complete Travel & Business Solutions Under One Roof" />
          <p style={{ textAlign: 'center', fontSize: '14px', color: '#6b7a8f', marginBottom: '40px', maxWidth: '900px', margin: '0 auto 40px', lineHeight: 1.8 }}>
            At DIRA Holidays, we provide comprehensive travel and business solutions designed for leisure travellers, corporate organisations, educational institutions, and travel partners. From planning and documentation to transportation and destination management, we deliver seamless, reliable, and personalised services under one roof.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '40px' }}>
            {SOLUTIONS.map((s, i) => (
              <SolutionCard key={i} v={s} />
            ))}
          </div>
          <QuoteText text="From planning and documentation to destination management and logistics, DIRA Holidays delivers complete travel solutions with professionalism, reliability, and personalised service." style={{ textAlign: 'center' }} />
        </div>

        {/* Hotel & Hospitality Network */}
        <div style={{ marginBottom: '80px', background: '#f8f9fa', padding: '60px 32px', borderRadius: '24px' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <SectionHead eyebrow="HOTEL & HOSPITALITY NETWORK" title="Quality Accommodation for Every Journey" />
            <p style={{ textAlign: 'center', fontSize: '14px', color: '#6b7a8f', marginBottom: '50px', lineHeight: 1.8 }}>
              DIRA Holidays collaborates with a trusted network of hotels and hospitality providers to offer comfortable, reliable, and high-quality accommodation for every type of traveller. Whether it's a luxury holiday, a corporate business trip, a family vacation, or a group tour, we carefully select properties that deliver exceptional comfort, convenience, and value.
            </p>

            <h4 style={{ fontSize: '20px', fontWeight: 800, color: 'var(--brand)', marginBottom: '24px', textAlign: 'center' }}>Our Hospitality Solutions</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', marginBottom: '40px' }}>
              {HOSPITALITY_SOLUTIONS.map((s, i) => (
                <SolutionCard key={i} v={s} />
              ))}
            </div>

            <div style={{ marginBottom: '50px' }}>
              <h4 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--brand)', marginBottom: '20px', textAlign: 'center' }}>Accommodation Options</h4>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center' }}>
                {ACCOMMODATION_OPTIONS.map((opt) => (
                  <span key={opt} style={{ padding: '8px 16px', background: '#fff', border: '1.5px solid #e2e8f0', borderRadius: '30px', fontSize: '13px', fontWeight: 600, color: '#3d4a5c', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                    {opt}
                  </span>
                ))}
              </div>
            </div>

            <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto', marginBottom: '40px' }}>
              <h4 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--brand)', marginBottom: '16px' }}>Our Commitment</h4>
              <p style={{ fontSize: '14px', color: '#6b7a8f', lineHeight: 1.8, margin: 0 }}>
                Every accommodation is selected based on quality, comfort, location, service standards, and value, ensuring our clients enjoy a safe, comfortable, and memorable stay throughout their journey.
              </p>
            </div>

            <QuoteText text="Partnering with trusted hospitality providers to deliver comfort, quality, and exceptional guest experiences." style={{ textAlign: 'center' }} />
          </div>
        </div>

        {/* All brand universes */}
        <SectionHead eyebrow="All Brand Experiences" title="Find Your Travel Universe" />
        <div
          className="Experiences_universes_grid"
          style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '14px' }}
        >
          {BRANDS.map((b) => (
            <BrandCardLight key={b.id} brand={b} onClick={(page) => navigate(`/${page}`)} />
          ))}
        </div>
      </div>
    </div>
  )
}
